<template>    
    <v-layout row wrap>
        <v-flex xs12>
            
            <v-snackbar
                v-model="showmessage"
                dismissible
                :color="messagetype"
                top
                :timeout="timeout"
                transition="scale-transition"
                vertical
            >
                {{statuscode}} {{message}}
                <v-btn
                    dark
                    flat
                    @click="switchOff"
                >
                    Close
                </v-btn>
            </v-snackbar>
    
            

        </v-flex>
    </v-layout>
         
</template>
<script>
    
    import { mapGetters } from 'vuex';
    import messagesmixin from '../../mixins/MessagesMixin.js';
    export default {
    mixins: [
        messagesmixin
    ],
    data () {
        return {
            timeout:4000
        }
    },
    methods:{
        switchOff(){
            this.$store.commit('messages/MESSAGES_INIT_MESSAGE')
        }
    }
    
    
  }
    
    

</script>
